import { Button } from '../../../../ui/button/button';
import { useParams } from 'react-router-dom';
import { PathParams } from '../../../../../routes/routing-path';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { DateFormatter } from '../../../../../utilities/date-formatter';
import iconAdjust2Screen from '../../../../../assets/img/icon/adjust2screen.svg';
import { TrimUiManager } from '../../../../../trim-editor/manager/ui/trim.ui.manager';
import { TrimPrintDetailType } from '../hooks/use-print-trim';
import { useQuery } from '../../../../../hooks/use-query';
import RangeSlider from '../../../../ui/input/range-slider';
import { NumInput } from '../../../../ui/input/numInput';
import ZoomController from '../../../../ui/zoom-controller/zoom-controller';

type Props = {
  printDetail: TrimPrintDetailType
};
const PrintTrimFooter = (props: Props) => {
  const { kijshopCd, shopOrderId, orderId } = useParams<PathParams>();
  const {printDetail} = props;
  const startDate = useMemo(() => DateFormatter.date2str(new Date(), 'YYYYMMDD_HHmmSS', '/'), []);
  const [isInitAlbumInfo, setIsInitAlbumInfo] = useState(false);
  const [checkedDescription, setCheckedDescription] = useState(false);
  const [isClick, setIsClick] = useState(false);
  const [zoomScale, setZoomScale] = useState(0);
  const query = useQuery();
  // - Callback -
  // -- 拡大 --
  const handlerClickZoomIn = useCallback(() => {
      TrimUiManager.ins.emit('r->t:zoom:lv:up', {});
  }, []);
  // -- 縮小 --
  const handlerClickZoomOut = useCallback(() => {
      TrimUiManager.ins.emit('r->t:zoom:lv:down', {});
  }, []);
  // -- フィット --
  const handlerClickZoomFit = useCallback(() => {
    TrimUiManager.ins.emit('r->t:zoom:fit', {});
  }, []);
  // -- 一時保存 --
  const handlerClickSaveTemp = useCallback(() => {
    TrimUiManager.ins.emit('r->t:valid:save-trim', {
      kijshopCd,
      shopOrderId,
      orderId,
      startDate,
    })
  }, []);
  // -- レイアウト完了 --
  const handlerClickComplete = useCallback(() => {
    TrimUiManager.ins.emit('r->t:valid:complete-trim', {
      kijshopCd,
      shopOrderId,
      orderId,
      startDate,
      moveMode: query.get('k') ?? '',
    })
  }, []);

  const onChangeZoomScale = useCallback((v: number) => {
    const scale = Math.floor(v);
    setZoomScale(scale);
    TrimUiManager.ins.emit('r->t:zoom:direct', { scale: scale/100 });
  }, []);

  useEffect(() => {
    const onChangeZoom = (e: { scale: number }) => {
      setZoomScale(Math.round(e.scale * 100));
    };
    // - TrimUiManager -
    TrimUiManager.ins.on('t->r:zoom:scale:change', onChangeZoom);
    return () => {
      TrimUiManager.ins.off('t->r:zoom:scale:change', onChangeZoom);
    };
  }, []);

  return (
    <div
      className="trim_footer"
      onClick={() => TrimUiManager.ins.emit('r->t:dis-select')}
    >
      <div className="trim_footer__info">
        <div>
          <div>【商品名】{printDetail.brandName}</div>
        </div>
        <div>
          <div>【ペーパー種】{printDetail.paperName}</div>
          {printDetail.lamiName ? (
            <div>【ラミネート種】{printDetail.lamiName}</div>
          ) : <></>}
          <div>【フチ】{printDetail.borderName}</div>
          {printDetail.tapeName ? (
            <div>【テープ色】{printDetail.tapeName}</div>
          ) : <></>}
          {printDetail.matName ? (
            <div>【マット】{printDetail.matName}</div>
          ) : <></>}
          <div>【注文番号】{printDetail.orderId}</div>
        </div>
      </div>

      <div className="trim_footer__size">
        <span>表示サイズ</span>
        {/*<Button*/}
        {/*  onClick={handlerClickZoomOut}*/}
        {/*  size="sm"*/}
        {/*  color="dark"*/}
        {/*  label="－"*/}
        {/*/>*/}
        <ZoomController zoomScale={zoomScale} callback={onChangeZoomScale} />
        {/*<Button*/}
        {/*  onClick={handlerClickZoomIn}*/}
        {/*  size="sm"*/}
        {/*  color="dark"*/}
        {/*  label="＋"*/}
        {/*/>*/}
        <Button
          onClick={handlerClickZoomFit}
          size="sm"
          color="dark"
          icon={<img src={iconAdjust2Screen} />}
          className="btn_adjust"
        />
      </div>

      <div className="trim_footer__operation">
        <Button
          label="一時保存"
          onClick={() => {
            if (!isClick) {
              handlerClickSaveTemp();
              setIsClick(true);
            }
            window.setTimeout(() => {
              setIsClick(false);
            }, 500);
          }}
          size="sm"
          color="secondary"
        />
        <Button
          label="完了"
          onClick={() => {
            if (!isClick) {
              handlerClickComplete();
              setIsClick(true);
            }
            window.setTimeout(() => {
              setIsClick(false);
            }, 500);
          }}
          size="sm"
        />
      </div>
    </div>
  );
};

export default PrintTrimFooter;
